import { themes } from '@electricjs/arc';
import { DefaultTheme } from 'styled-components';

/**
 * Trinet custom theme - Only overrides primary color
 *
 * This extends the base Electric theme and only replaces the primary color
 * with Trinet's brand color (#FFD4C7). All other Arc components will
 * automatically use this color for primary buttons, active states, etc.
 *
 * NOTE: The overwritten color values were provided by the TriNet team as a reference to demonstrate the application's thematic capabilities. It is not the intention to create a completely new theme at this stage of the project.
 */
export const TRINET_LIGHT_THEME: DefaultTheme = {
  ...themes.ELECTRIC,
  colors: {
    ...themes.ELECTRIC.colors,
    // Trinet primary color - blue
    'colorV2-primary': '#044DBB', // Text label and caret color
    'colorV2-primary-dark': '#5C9DFF', //Highlighted Text Color
    'colorV2-primary-darkest': '#5C9DFF', //Highlighted Button Color
    'colorV2-primary-light': '#5C9DFF', //Hover Outline Color
    'colorV2-primary-lightest': '#F0F5FF', //Tab fill color
    // Remove button fill gradient
    'colorV2-gradient-button-fill': 'none',
    // Focus ring using TriNet primary (RGB 4, 77, 187)
    'colorV2-focus-ring':
      '0 0 0 2px rgba(4, 77, 187, 0.15), 0 0 8px 3px rgba(4, 77, 187, 0.10)',
  },
  name: 'TriNet Light',
};

/**
 * Trinet Dark theme - Extends Electric Dark with Trinet brand colors
 *
 * TODO: Replace placeholder values below with actual tokens from TriNet.
 */
export const TRINET_DARK_THEME: DefaultTheme = {
  ...themes.ELECTRIC_DARK,
  colors: {
    ...themes.ELECTRIC_DARK.colors,
    // ── TriNet Dark tokens (replace these with real values from TriNet) ──
  },
  name: 'TriNet Dark',
};
